import { mutationRequest } from "../util/request"

export interface Donation {
  id: number
  amount: number
  band_share: number
  bn_share: number
  promotion_share: number
  tipper_name: string
  tipper_email: string
  tip_date: string
}

export interface DonationsIndexResponse {
  success: boolean
  total_count: number
  total_amount: number
  page: number
  total_pages: number
  has_next_page: boolean
  tips: Donation[]
}

/**
 * Get all completed donations for a post (band management view)
 */
export async function getDonationsForPost(
  postId: number,
): Promise<DonationsIndexResponse> {
  return mutationRequest({
    options: { method: "GET" },
    path: `/api/v1/posts/${postId}/tips`,
  })
}

export interface GuestDonationCheckoutParams {
  postId: number
  bandId: number
  email: string
  paymentMethodId: string
  amount: number
  redirectUrl?: string
  saveCard?: boolean
}

export interface GuestDonationCheckoutResponse {
  success: boolean
  is_new_user?: boolean
  user_token?: string
  tip?: {
    id: number
    amount: number
    status: string
  }
  error?: string
  error_code?: string
  stripe_error?: string
}

/**
 * Donate to a show as a guest (no account required)
 */
export async function guestDonationCheckout(
  params: GuestDonationCheckoutParams,
): Promise<GuestDonationCheckoutResponse> {
  return mutationRequest({
    options: { method: "POST" },
    path: `/api/v1/guest_tips`,
    data: {
      post_id: params.postId,
      band_id: params.bandId,
      email: params.email,
      payment_method_id: params.paymentMethodId,
      amount: params.amount,
      redirect_url: params.redirectUrl,
      save_card: params.saveCard ?? true,
    },
  })
}
